<template>
  <div id="app" class="app">
    <!-- <div
      class="bg zuo"
      :style="{ width: (screenWidth - 525) / 2 + 'px' }"
    ></div> -->
    <div class="content" :class="currentRoute == 'home' ? 'homeBg' : ''"
      :style="{ 'max-width': isMobileOrTablet() ? '768px' : '430px' }">
      <headerTop v-if="shouldShowHeaderTop" id="headerTop" ref="headerTopRef" @showLogin="showLogin"></headerTop>
      <router-view class="appview" v-if="!$route.meta.iskeep"></router-view>
      <keep-alive>
        <router-view class="appview" v-if="$route.meta.iskeep"></router-view>
      </keep-alive>
      <!-- <WipeSidebar :slider="slider" class="cesildera"></WipeSidebar> -->
      <slider v-if="slider" class="App_slider"></slider>
      <illustrate v-if="isillustrate" class></illustrate>

      <bottomUser v-if="shouldShowBottom" id="bottomUser"
        :style="{ 'max-width': isMobileOrTablet() ? '768px' : '430px' }"></bottomUser>
      <login :showModal="show" @close="show = false" :inviteCode="inviteCode"></login>
    </div>
    <!-- <div
      class="bg you"
      :style="{ width: (screenWidth - 525) / 2 + 'px' }"
    ></div> -->
    <!-- <audio ref="audioPlayer" :src="musicSrc" loop style="display: none;"></audio> -->
  </div>
</template>
<script></script>
<script>
import login from "@/views/Home/common/login.vue";
import slider from "@/components/sliderUser.vue";
import { getToken } from "@/api/cookie";

import headerTop from "@/components/headerTop.vue";
import bottomUser from "@/components/bottomUser.vue";
import WipeSidebar from "@/components/WipeSidebar.vue";
import store from "@/vuex/store";
export default {
  data() {
    return {
      he: 0,
      // width: window.innerWidth
      show: false,
      slider: false,
      isillustrate: false,
      w: document.documentElement.clientWidth,
      screenWidth: document.body.clientWidth, // 屏幕宽度
      currentRoute: this.$route.name,
      musicSrc: new Audio(require("./assets/home.mp3")),
      isPlaying: false, // 跟踪音频播放状态
      routesToShowHeader: ["home", "share", "knapsack"],
      routesToShowBottom: ["home", "share", "knapsack", "recharge", "home2"], // 需要显示 headerTop 的路由名称列表
      inviteCode: "",
    };
  },
  components: {
    login,
    headerTop,
    slider,
    bottomUser,
    WipeSidebar,
  },
  computed: {
    shouldShowHeaderTop() {
      return this.routesToShowHeader.includes(this.$route.name);
    },
    shouldShowBottom() {
      // console.log(this.$route.name);
      return this.routesToShowBottom.includes(this.$route.name);
    },
  },
  watch: {
    $route(to) {
      this.currentRoute = to.name;
      // this.getToken()
      if (this.$store.state.LOGIN_IS_SHOW) {
        setTimeout(() => {
          // 判断是否存储邀请码
          this.inviteCode = localStorage.getItem("inviteCode");
          this.show = true;
        }, 500);
      }
    },
  },
  mounted() {
    const query = new URLSearchParams(window.location.search);
    const code = query.get("code");
    // 存储缓存
    if (code) {
      localStorage.setItem("inviteCode", code);
      this.inviteCode = code;
    }

    // 添加全局点击事件监听器
    document.addEventListener("click", this.handleGlobalClick);
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
    this.$nextTick(() => {
      this.$store.commit("playAudio");
    });
    console.log("window.history.state", window.history.state);
    if (window.history.state && window.history.state.title) {
      if (this.$store.state.LOGIN_IS_SHOW) {
        this.show = true;
        return;
      } else {
        window.history.back();
      }
    }
    let aa = document.getElementById("headerTop").offsetHeight;
    let bb = document.getElementById("bottomUser").offsetHeight;
    this.he = aa + bb;

    // this.getToken();

    this.$bus.$on("close", (data) => {
      this.show = data;
      if (!data) {
        // this.$router.back();
        if (window.history.length > 1) {
          this.$router.back();
        } else {
          this.$router.push("/");
        }
      }
      // this.$router.back()
      // window.history.back()
    });
    this.$bus.$on("is_illustrate", (data) => {
      this.isillustrate = data;
    });
    this.$bus.$on("sliderbtn", (data) => {
      this.slider = data;
    });
    // 接收退出变量
    this.$bus.$on("logOut", () => {
      // 通知顶部清掉数据
      this.$refs.headerTopRef.clearData();
    });
  },
  beforeDestroy() {
    // 移除全局点击事件监听器
    document.removeEventListener("click", this.handleGlobalClick);
  },
  methods: {
    showLogin() {
      this.show = true;
    },
    // getToken() {
    //   if (getToken()) {
    //     this.show = false;
    //     this.$store.commit("LOGIN_IS_SHOW", false);

    //     this.$bus.$emit("islogin", this.show);
    //   } else {
    //     setTimeout(() => {
    //       // this.$router.push("/login");
    //       this.show = true;
    //       this.$bus.$emit("islogin", this.show);
    //       this.$store.commit("LOGIN_IS_SHOW", true);
    //     }, 500);
    //   }
    // },
    isMobileOrTablet() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // 检查是否为移动设备或平板设备
      if (
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|windows phone|android|kindle|silk/i.test(
          userAgent
        )
      ) {
        return true;
      }

      // 特殊情况：某些Android平板可能包含'Mobile'，但屏幕分辨率较大
      if (/android/i.test(userAgent) && /mobile/i.test(userAgent)) {
        // 这里可以添加额外的逻辑，比如根据屏幕宽度判断是否为平板
        // 例如，使用window.screen.width > 600作为平板的阈值
        if (window.screen.width > 600) {
          return true;
        }
      }

      // 如果以上条件都不满足，则认为是电脑端
      return false;
    },

    getToken() {
      if (getToken()) {
        this.show = false;
        this.$store.commit("LOGIN_IS_SHOW", false);

        this.$bus.$emit("islogin", this.show);
      } else {
        setTimeout(() => {
          // this.$router.push("/login");
          this.show = true;
          this.$bus.$emit("islogin", this.show);
          this.$store.commit("LOGIN_IS_SHOW", true);
        }, 500);
      }
    },
    handleGlobalClick() {
      let music = localStorage.getItem("music") === "false" ? false : true;
      // console.log('music', music)
      if (!this.isPlaying && music) {
        if (this.shouldShowBottom) {
          this.$soundPlay("indexBgm");
        }
        // this.$store.commit("playGlobalMusic");
        // this.isPlaying = true; // 更新播放状态
        // console.log('音乐开始播放...');
      } else if (!music) {
        // this.$store.commit("stopGlobalMusic")
        this.$soundStop("indexBgm");
      }
    },
  },
};
</script>

<style lang="scss">
#bottomUser {
  position: absolute;
  bottom: 0px;
  width: 100vw;
  height: 70px;
  z-index: 99;
  // background-position: center bottom;
  // background-size: 100% 100%;
  // background-image: url("./assets/images/app_ft_1.png");
  background-color: #000;
  box-sizing: border-box;
  max-width: 768px;

  @media only screen and (max-width: 430px) {
    position: fixed !important;
    bottom: 0 !important;
    font-size: 2.85vw;
  }
}

.App_slider {
  position: absolute;
  right: 15px;
  top: 30%;
  animation: slider 0.3s linear;
}

@keyframes slider {
  0% {
    right: -72px;
  }

  75% {
    right: 18px;
  }

  100% {
    right: 15px;
  }
}

.App_login {
  animation: mymove 0.3s linear;
}

@keyframes mymove {
  0% {
    top: -10px;
    opacity: 0.7;
  }

  100% {
    top: 0;
    opacity: 1;
  }
}

.cesildera {
  position: absolute;
  right: 30px;
  bottom: 200px;
}

.appview {
  // overflow-y: scroll;
  position: relative;
  // height: calc(100vh - 184px);
  height: 100vh;
  // padding-bottom: 200px;
}

@media (max-width: 430px) {
  .appview {
    height: 100vh;
    // padding-top: 60px;
  }
}

.appview::-webkit-scrollbar {
  display: none;
}

.appview::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  opacity: 0.2;
}

.appview::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 5px;
}

.appview::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.content {
  text-align: center;
  margin: 0 auto;
  color: #fff;
  height: 100vh;
  width: 100vw;
  position: relative;
  font-size: 1rem;
  max-width: 768px;
}

.content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // background: url("./assets/images/home_bg.gif") no-repeat center center;
  background: url('~@/assets/home/bj.png') no-repeat center center;
  // background-size: 100% 100% !important;
  background-size: cover;
  // opacity: 0.8; /* 设置背景图片的透明度 */
  z-index: 0;
  /* 确保背景图片在文字后面 */
}

.homeBg::before {
  // content: "";
  // position: absolute;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  // background: url("./assets/images/home_bg.gif") no-repeat top center;
  // background-size: cover;
  // opacity: 0.8; /* 设置背景图片的透明度 */
}

.content::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.53);
  /* 黑色蒙版，透明度为 0.6 */
  z-index: -1;
  /* 确保蒙版在背景图片之上，文字之下 */
}

.zuo {
  background: url("../public/1.jpg") no-repeat right center;
  background-size: cover;
}

.you {
  background: url("../public/you.jpg") no-repeat left center;
  background-size: cover;
}

#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: "Microsoft Yahei";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  height: 100vh;
  width: 100vw;
  position: relative;
  font-size: 1rem;
  -moz-user-select: -moz-none;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: auto;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  justify-content: center;
  background: url("./assets/home.webp") no-repeat center center;
  background-size: cover;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

a {
  text-decoration: none;
}

img {
  vertical-align: middle;
}

svg {
  display: block;
  margin: auto;
}

input {
  all: unset;
  /* 清除所有浏览器默认样式 */
  box-sizing: border-box;
  /* 确保 padding 和 border 不会影响元素的总宽度 */
  font-family: inherit;
  /* 继承父元素字体 */
  font-size: 100%;
  /* 继承父元素字体大小 */
  text-align: left;
}

.digit-div {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.digit-div .num-data {
  display: inline-block;
  width: 2.83 * 4.2px;
  height: 4.4 * 4.2px;
  background-size: 2.83 * 4.2px 57.2 * 4.2px;
  background-repeat: no-repeat;
  background-image: url("./assets/images/number_box.png");
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
}

.digit-div .offset_-4 {
  margin: 0 0.67 * 4.2px 0 -1px;
}

.digit-div .offset_0 {
  margin: 0 -0.5px 0 0;
}

.digit-div .offset_1 {
  margin: 0 -1px 0 -1px;
}

.digit-div .offset_2 {
  margin: 0 -0.27 * 4.2px 0 -1px;
}

.digit-div .offset_3 {
  margin: 0 -0.4 * 4.2px 0 -1px;
}

.digit-div .offset_4 {
  margin: 0 -0.53 * 4.2px 0 -1px;
}

.digit-div .offset_5 {
  margin: 0 -0.67 * 4.2px 0 -1px;
}

.digit-div .no-num {
  margin: 0 -0.67 * 4.2px 0 -0.67 * 4.2px;
}

.digit-div .code_0 {
  background-position: center top 0px;
}

.digit-div .code_1 {
  background-position: center top -4.4 * 4.2px;
}

.digit-div .code_2 {
  background-position: center top -8.8 * 4.2px;
}

.digit-div .code_3 {
  background-position: center top -13.2 * 4.2px;
}

.digit-div .code_4 {
  background-position: center top -17.6 * 4.2px;
}

.digit-div .code_5 {
  background-position: center top -22 * 4.2px;
}

.digit-div .code_6 {
  background-position: center top -26.4 * 4.2px;
}

.digit-div .code_7 {
  background-position: center top -30.8 * 4.2px;
}

.digit-div .code_8 {
  background-position: center top -35.2 * 4.2px;
}

.digit-div .code_9 {
  background-position: center top -39.6 * 4.2px;
}

.digit-div .code_10 {
  background-position: center top -44 * 4.2px;
}

.digit-div .code_11 {
  background-position: center top -48.4 * 4.2px;
}

.digit-div .code_12 {
  background-position: center top -52.8 * 4.2px;
}

.digit-div.digit-div-red .num-data {
  background-image: url("./assets/images/digit_2.png");
}

.digit-div.digit-div-red .no-num {
  margin: 0 -1.33 * 4.2px 0 -1px;
}

.digit-div.digit-div-blue .num-data {
  background-image: url("./assets/images/digit_3.png");
}

.digit-div.digit-div-blue .no-num {
  margin: 0 -1.33 * 4.2px 0 -1px;
}

.appFont {
  font-family: appFont;
}

.flex-box {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.flex-column {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.flex-column-center {
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.flex-all-center {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.flex-horizontal {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}

.flex-horizontal-center {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

/* flex */

.flex-center {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-align-items: center;
}

/* flex */

.flex-start {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-align-items: center;
}

.fixed-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.text-ellipsis {
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.abs-base {
  position: absolute;
  top: 0;
  left: 0;
}

.abs-full {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.no-data .empty-box-new {
  position: relative;
  width: 100%;
  height: 66px;
  background: url("./assets/roll/6.png") no-repeat center center / 63px 63px;
}

.no-data .tip-text {
  text-align: center;
  color: #999999;
  font-size: 14px;
  margin-top: 4.29 * 4.2px;
  z-index: 9999;
}

// 背景图片
.page-content-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  z-index: 0;
}

.page-content-bg .bg-layer1 {
  position: absolute;
  top: 0;
  // top: 8.8 * 4.2px;
  left: 0px;
  width: 100%;
  height: 100%;
  // background: url("./assets/images/page_ct_bk2.png") repeat-y top center / 100% auto;
  background: url("~@/assets/roll/5.png") no-repeat top center / 80% auto;
  background-size: 90% 80%;
}

.page-content-bg .bg-layer1-frag {
  background: url("./assets/images/page_ct_bk3.png") repeat-y top center / 100% auto;
}

.page-content-bg .bg-layer2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("./assets/images/page_ct_bk1.png") no-repeat top center / 100% 8.8 * 4.2px;
}

// 默认货币大小
.default-currency {
  width: 22.386px;
  height: 22.386px;
}

.zz-page {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  color: white;
  background-image: url("./assets/home/bj.png") no-repeat 0 0;
  background-size: 100% 100%;
  // overflow-y: scroll;
}

.page-content-new {
  width: 100%;
  z-index: 2;
  position: relative;
  min-height: 100%;
}

.page-content-new {
  z-index: unset;
}

.flex-box-div {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 100%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // padding-top: -webkit-calc(var(--head-height));
  // padding-top: calc(var(--head-height));
}

// 滚动条样式
/* 设置所有滚动条的宽度 */
*::-webkit-scrollbar {
  width: 2px;
}

/* 设置滚动条轨道的颜色和透明度 */
*::-webkit-scrollbar-track {
  background-color: #8a9ddf;
  opacity: 0.2;
}

/* 设置滚动条滑块的颜色和圆角 */
*::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 5px;
}

/* 当鼠标悬停在滚动条滑块上时改变颜色 */
*::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.buy-box {
  padding-top: 16 * 4.2px;
  padding-bottom: 10.67 * 4.2px;
  font-size: 3.33 * 4.2px;
  font-weight: normal;
  color: #a6bbff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.buy-box .price {
  font-size: 4.4 * 4.2px;
  font-weight: bold;
  color: #f2c2a2;
  margin: 0 1.33 * 4.2px;
}

.tips {
  color: #ff5e5e;
  font-size: 12px;
  width: 100%;
  line-height: 2;
  text-align: left;
  margin-top: 10px;
}

// 筛选
.filter-box {
  width: auto;
  height: 16.53 * 4.2px;
  padding-left: 2.67 * 4.2px;
}

.filter-box .filter-btn {
  width: 39.47 * 4.2px;
  height: 8.5vw;
  background: url("./assets/knapsack/1.png") no-repeat 0 0;
  // background: url("./assets/images/k2.png") no-repeat 0 0;
  background-size: 39.47 * 4.2px 8.53 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.filter-box .filter-btn .el-dropdown-link {
  display: flex;
}

.filter-box .text {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  line-height: 8.53 * 4.2px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  padding: 0px 4px;
  box-sizing: border-box;
  min-width: 120px;
}

.filter-box .right-icon {
  width: 10.27 * 4.2px;
  height: 8.53 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.filter-box .right-icon .line {
  width: 1px;
  height: 2.93 * 4.2px;
  margin-right: 2.4 * 4.2px;
}

.filter-box .right-icon .arrow-icon {
  width: 4.93 * 4.2px;
  height: 2.93 * 4.2px;
}

.filter-box .select-box {
  width: 39.47 * 4.2px;
  height: auto;
}

.filter-box .select-box .sort-item {
  width: 100%;
  height: 10.67 * 4.2px;
  line-height: 10.67 * 4.2px;
  text-align: center;
}

.bottom-tab-wrap {
  width: 100%;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  bottom: -9.73 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding-left: 4.8 * 4.2px;
}

.bottom-tab-wrap .tab-item {
  width: 27.2 * 4.2px;
  height: 9.87 * 4.2px;
  line-height: 9.87 * 4.2px;
  background: url("./assets/images/k40.png") no-repeat 0 0;
  background-size: 27.2 * 4.2px 8.93 * 4.2px;
  font-size: 4.4 * 4.2px;
  color: #b3c6ff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-bottom: 0.8 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-right: 1.07 * 4.2px;
}

.bottom-tab-wrap .tab-item.sel {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #fff;
  background-image: url("./assets/images/bottom_tab_item_sel.png");
  background-size: 28.13 * 4.2px 9.87 * 4.2px;
  background-repeat: no-repeat;
  background-position: top -0.4 * 4.2px center;
}

.no-data {
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  font-size: 20px;
  color: #fff;
  width: 100%;
  margin-top: 24vh;
}

@media only screen and (max-width: 430px) {
  .buy-box {
    padding-top: 16vw;
    padding-bottom: 10.67vw;
    font-size: 3.33vw;
  }

  .buy-box .price {
    font-size: 4.4vw;

    margin: 0 1.33vw;
  }

  .filter-box {
    height: 16.53vw;
    padding-left: 2.67vw;
  }

  .filter-box .filter-btn {
    width: 39.47vw;
    height: 8.5vw;

    background-size: 39.47vw 8.53vw;
  }

  .filter-box .text {
    line-height: 8.53vw;
    min-width: 29vw;
  }

  .filter-box .right-icon {
    width: 10.27vw;
    height: 8.53vw;
  }

  .filter-box .right-icon .line {
    width: 1px;
    height: 2.93vw;
    margin-right: 2.4vw;
  }

  .filter-box .right-icon .arrow-icon {
    width: 4.93vw;
    height: 2.93vw;
  }

  .filter-box .select-box {
    width: 39.47vw;
  }

  .filter-box .select-box .sort-item {
    height: 10.67vw;
    line-height: 10.67vw;
  }

  .bottom-tab-wrap {
    bottom: -9.73vw;

    padding-left: 4.8vw;
  }

  .bottom-tab-wrap .tab-item {
    width: 27.2vw;
    height: 9.87vw;
    line-height: 9.87vw;

    background-size: 27.2vw 8.93vw;
    font-size: 4.4vw;

    padding-bottom: 0.8vw;

    margin-right: 1.07vw;
  }

  .bottom-tab-wrap .tab-item.sel {
    background-size: 28.13vw 9.87vw;

    background-position: top -0.4vw center;
  }
}
</style>
